import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/institutions_top.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-e2b2b2a8"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "institution"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1);
});

var _hoisted_3 = {
  class: "formdata"
};
var _hoisted_4 = {
  class: "formitem"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "机构名称:", -1);
});

var _hoisted_6 = {
  class: "inputbox"
};
var _hoisted_7 = {
  class: "formitem"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "姓名:", -1);
});

var _hoisted_9 = {
  class: "inputbox"
};
var _hoisted_10 = {
  class: "formitem"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "label"
  }, "手机号:", -1);
});

var _hoisted_12 = {
  class: "inputbox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $setup.postdata.cooperateIntentionText = $event;
    }),
    type: "text",
    maxlength: "100",
    placeholder: "请输入机构名称"
  }, null, 512), [[_vModelText, $setup.postdata.cooperateIntentionText]])])]), _createElementVNode("li", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $setup.postdata.userName = $event;
    }),
    type: "text",
    maxlength: "20",
    placeholder: "请输入姓名"
  }, null, 512), [[_vModelText, $setup.postdata.userName]])])]), _createElementVNode("li", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $setup.postdata.phoneNumber = $event;
    }),
    type: "text",
    maxlength: "11",
    placeholder: "请输入手机号"
  }, null, 512), [[_vModelText, $setup.postdata.phoneNumber]])])])]), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[3] || (_cache[3] = function () {
      return $setup.postInst && $setup.postInst.apply($setup, arguments);
    })
  }, "我 要 合 作")])]);
}